import React, { useEffect, useState } from 'react';

export function Timer({ timer, endTimer }) {
    const [time, setTime] = useState(null);

    useEffect(() => {
        const endTime = Date.now() + timer * 1000;

        const interval = setInterval(() => {
            const newTime = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
            setTime(newTime);

            if (newTime === 0) {
                endTimer();
                clearInterval(interval);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [endTimer, timer]);

    return <span>{time}</span>;
}
